export default "__VITE_ASSET__PFjSFypB__"